import { API_ENDPOINTS } from '@analytics/const';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccRRList, RRList } from '@reference/const';
import { getRoute } from '@shared/utils';
import { OccEndpointsService, WindowRef } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class ProductReferenceApiService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private windowRef: WindowRef,
  ) {}

  loadRetailRocketRecomendationList(
    productIds: string[],
    algorithms: string,
    cityId: string,
    rcuid: string,
  ): Observable<RRList> {
    const url = this.occEndpointsService.buildUrl(API_ENDPOINTS.RRUrl, null, {
      prefix: false,
      baseSite: false,
    });

    if (!algorithms) {
      return of({ recommendations: [] });
    }

    const strategies = algorithms.split(',');

    const body = JSON.stringify({
      productIds,
      strategies,
      cityId,
      options: { rcuid },
    });

    const currentHref = this.windowRef.location?.href?.split('?')[0] ?? '';
    const pageRoute = getRoute(currentHref, currentHref);

    return this.http
      .post<OccRRList>(url, body, {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          // передаем адрес страницы на которой отрисована карусель
          // для логов и аналитики
          baggage: `page-route=${pageRoute}`,
        }),
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, url),
      })
      .pipe(
        map((data: OccRRList) => {
          return {
            recommendations: data.productCodes,
          };
        }),
      );
  }
}
